export const supportAccount = {
  avatar:
    'https://static.vecteezy.com/system/resources/previews/033/522/525/non_2x/cartoon-character-cute-avatar-24-7-technical-support-staff-isolated-on-white-background-three-dimensional-girl-photo.jpg',
  name: 'Customer Support',
};
